import React from 'react';
import '../../styles/christmas.css';
import bellImage from '../../assets/images/bell.png';

/**
 * Header Decorations component - adds festive corner decorations
 * Displays subtle Christmas elements in header corners
 */
const HeaderDecorations = () => {
  return (
    <div className="christmas-header-decorations" aria-hidden="true">
      {/* Bell at left top corner */}
      <div className="decoration decoration-bell">
        <img src={bellImage} alt="Christmas Bell" className="bell-image" />
      </div>
      
      {/* Top left decoration */}
      <div className="decoration decoration-top-left">
        <span className="decoration-icon">🎄</span>
      </div>
      
      {/* Top right decoration */}
      <div className="decoration decoration-top-right">
        <span className="decoration-icon">⭐</span>
      </div>
      
      {/* Additional subtle elements */}
      <div className="decoration-lights">
        <span className="light light-red" style={{ left: '15%' }}>●</span>
        <span className="light light-green" style={{ left: '30%' }}>●</span>
        <span className="light light-gold" style={{ left: '45%' }}>●</span>
        <span className="light light-red" style={{ left: '55%' }}>●</span>
        <span className="light light-green" style={{ left: '70%' }}>●</span>
        <span className="light light-gold" style={{ left: '85%' }}>●</span>
      </div>
    </div>
  );
};

export default HeaderDecorations;
